<template>
  <div class="medal-popup-component">
    <center-popup class="popup-medal"
                  :show.sync="visible"
    >
      <h4 class="popup-medal-title">{{ title }}</h4>
      <ym-img class="popup-medal-img"
              :src="src"
              :alt="title"
      />
      <div class="medal-desc">{{ desc }}</div>
    </center-popup>
  </div>
</template>

<script>
  import CenterPopup from '@/components/CenterPopup';

  export default {
    name: 'MedalPopup',
    components: {
      CenterPopup,
    },
    data() {
      return {
        visible: false,
      };
    },
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      src: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      desc: {
        type: String,
        required: true,
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @medal-popup-size: 200px;

  .popup-medal {
    text-align: center;
    padding: 52px 0 86px;
    /deep/ .popup-content {
      padding: 0 68px;
    }
  }

  .popup-medal-title {
    margin: 0 0 52px;
    font-size: @font-size-large;
  }

  .popup-medal-img {
    display: block;
    width: @medal-popup-size;
    margin: 0 auto @size-medium;
  }

  .medal-desc {
    font-size: @font-size-small;
    line-height: 1.5;
  }
</style>
